import { IImageProp } from '@/constants';
import WebAppIcon from '@/images/layout/pc-web.svg';
import MobilePhoneIcon from '@/images/layout/mobile-app.svg';
import ChromeExtensionIcon from '@/images/layout/chrome-extension.svg';
import VideoRecordIcon from '@/images/layout/video-record.svg';
import AISummaryIcon from '@/images/layout/ai-summary.svg';
import CalendarIcon from '@/images/layout/calendar-book.svg';
import MinutesIcon from '@/images/layout/public-summary.svg';
// import FeaturesIcon from '@/images/layout/public-upgrade.svg';
// import ImportCaseIcon from '@/images/layout/import-cases.svg';

export interface INavItem {
  title: string;
  icon: IImageProp;
  link: string;
  hoverBg?: string;
  desc?: string;
}

export interface IDropdownListItem {
  title?: string;
  navItemList: INavItem[];
}

export interface IHeaderNavDropdown {
  type: 'dropdown';
  label: string;
  dropdownList: IDropdownListItem[];
}

export interface IHeaderNavLink {
  type: 'link';
  label: string;
  link: string;
}

export const HEADER_NAV_DATA: (IHeaderNavDropdown | IHeaderNavLink)[] = [
  {
    type: 'dropdown',
    label: 'プロダクト',
    dropdownList: [
      {
        title: 'プロダクト',
        navItemList: [
          {
            title: 'Web版',
            link: '/web',
            icon: {
              src: WebAppIcon,
              alt: 'Web版',
            },
            desc: 'PCでインストール不要の文字起こしツール',
            hoverBg: '#F1F0FC',
          },
          {
            title: 'アプリ',
            link: '/mobile',
            icon: {
              src: MobilePhoneIcon,
              alt: 'アプリ',
            },
            desc: 'iOS/Androidで使える文字起こしアプリ',
            hoverBg: '#FDF1F7',
          },
          {
            title: 'Chrome拡張機能',
            link: '/chrome-extension',
            icon: {
              src: ChromeExtensionIcon,
              alt: 'Chrome拡張機能',
            },
            desc: '同時に複数のWebページで再生している音声を文字起こし',
            hoverBg: '#FEF9EC',
          },
        ],
      },
      {
        title: '機能一覧',
        navItemList: [
          {
            title: 'AI要約',
            link: '/features/ai-summary',
            icon: {
              src: AISummaryIcon,
              alt: 'AI要約',
            },
            desc: '迅速に有用な情報を抽出し、人手や時間のコストを削減',
            hoverBg: '#F1FAFE',
          },
          {
            title: 'スケジュール機能',
            link: '/features/scheduler',
            icon: {
              src: CalendarIcon,
              alt: 'スケジュール機能',
            },
            desc: '会議の予約から文字起こしまでたったのワンステップで済む',
            hoverBg: '#F1FAFE',
          },
          {
            title: '画面録画',
            link: '/features/screen-recorder',
            icon: {
              src: VideoRecordIcon,
              alt: '画面録画',
            },
            desc: '録画と文字起こしを残して、情報の再利用を効率化',
            hoverBg: '#F1FAFE',
          },
          {
            title: '議事録',
            link: '/features/minutes',
            icon: {
              src: MinutesIcon,
              alt: '議事録',
            },
            desc: '会議の内容をすべて記録し、議事録の作成をサポート',
            hoverBg: '#F1FAFE',
          },
        ],
      },
    ],
  },
  {
    type: 'link',
    label: 'サポート',
    link: 'https://support.notta.ai/hc/ja',
  },
  {
    type: 'link',
    label: 'ブログ',
    link: '/blog',
  },
  {
    type: 'link',
    label: '料金プラン',
    link: '/pricing',
  },
  {
    type: 'link',
    label: '法人向け',
    link: '/business',
  },
  {
    type: 'link',
    label: '資料請求',
    link: '/about',
  },
  {
    type: 'link',
    label: '導入事例',
    link: '/cases',
  },
];
